<template>
  <div></div>
</template>

<script>
import { Bus } from "../main";

export default {
  name: "FormText",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      metadata: this.field.metadata,
    }
  },
  mounted() {
    this.insertContent();
    Bus.$on("refreshText", (area) => {
      if (this.field.layout.seq === area.layout.seq) {
        this.metadata = area.metadata;
        this.insertContent();
      }
    })
  },
  methods: {
    insertContent: function () {
      this.$el.innerHTML = null;
      let size = "span";
      if (this.metadata.size) {
        size = this.metadata.size;
      }
      const element = document.createElement(size);
      element.innerText = this.metadata.content;
      this.$el.insertAdjacentElement("afterbegin", element);
    }
  },
  beforeDestroy() {
    Bus.$off("refreshText");
  },
};
</script>

<style scoped>
</style>